import React, { type FC, type JSX } from 'react';
import { CloseIconContainer, ModalHeaderContainer } from './styled';
import CloseIcon from '../../CloseIcon';

type ModalHeaderProps = {
  handleClose?: () => void;
  removeShadow?: boolean;
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  closeOnRight?: boolean;
  // Accessible name for the icon-only close button. Defaults to a generic label;
  // pass a descriptive one (e.g. "Close Your trip") so screen readers announce context.
  closeLabel?: string;
};

const BasicModalHeader: FC<ModalHeaderProps> = ({
  children,
  removeShadow,
  className = '',
  handleClose,
  style,
  closeOnRight,
  closeLabel = 'Close',
}): JSX.Element => (
  <ModalHeaderContainer removeShadow={removeShadow} className={className} style={style}>
    {handleClose && (
      <CloseIconContainer
        type="button"
        aria-label={closeLabel}
        $closeOnRight={closeOnRight}
        onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
          // Radix Dialog portals the modal; React synthetic events still bubble through the
          // React tree back to the component that triggered the open. Stop propagation here to
          // prevent the parent opener (e.g., Feature button) from re-opening the modal.
          e.stopPropagation();
          handleClose();
        }}
      >
        <CloseIcon />
      </CloseIconContainer>
    )}
    {children}
  </ModalHeaderContainer>
);

export default BasicModalHeader;
